export default __webpack_public_path__ + "images/bullet3-adrkC.png";